module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-1000-ec15bd50989db7c37f7700ec80dde477.svg";